import type { IconSvgObject } from './types';

const SuperscriptIcon: IconSvgObject = [
  ["path", { d: "M2.71484 7.02474C4.70583 6.91997 5.95508 7.07715 6.73586 8.91069C7.55568 11.111 9.58571 17.2403 10.0932 18.6548C10.6398 20.174 11.3425 21.2218 14.2314 20.9598", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 7.00791C12.1371 6.98296 9.79479 11.7228 8.49349 13.9929C7.06206 16.6123 4.6026 21.1525 2 20.9779", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M22.0002 8.99985H18.0002L21.2003 6.59981C21.7039 6.22212 22.0002 5.62938 22.0002 4.9999C22.0002 3.89538 21.1047 2.99999 20.0001 3C18.8956 3.00001 18 3.89543 18 4.99998", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SuperscriptIcon;
